export default __webpack_public_path__ + "static/top10rankings-52f27d13f532b4e903d4ff361d9f5bfb.png";